import { render, staticRenderFns } from "./FormasValoradasPage.vue?vue&type=template&id=5d503080&"
import script from "./FormasValoradasPage.vue?vue&type=script&lang=js&"
export * from "./FormasValoradasPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports